(function() {
  'use strict';

  angular.module('ringbaPortal.services').factory('statePermissionService', statePermissionService);

  function statePermissionService(
    $log,
    $q,
    $state,
    $rootScope,
    accountsService,
    authService,
    featureFlags,
    termsService
  ) {
    'ngInject';

    const service = {
      checkStateRequirements: checkStateRequirements,
      checkIfUserAuthenticated: checkIfUserAuthenticated,
      checkTermsAccepted: checkTermsAccepted
    };

    return service;

    function checkStateRequirements(toState) {
      if (toState.data.permission || toState.data.requireAccount) {
        if (!accountsService.currentAccount) {
          return accountsService.loadAccountsData().then(function () {
            return _verifyPermissions(toState);
          });
        } else {
          return $q.when(_verifyPermissions(toState));
        }
      }
      return $q.when();
    }

    function checkIfUserAuthenticated(toState, previewStateForWhitelabel, toParams) {
      if ((typeof toState.data.redirectIfAuthed) !== 'undefined' && toState.data.redirectIfAuthed && authService.authentication.isAuth && !previewStateForWhitelabel) {
        return 'dashboard.main';
      } else if (toState.data.requireAuth && !authService.authentication.isAuth) {
        // Save the desired path in the root scope
        $rootScope.attemptedState = toState;
        $rootScope.attemptedParams = toParams;
        return 'login';
      }
    }

    /**
     * Login-time Terms & Conditions gate. Resolves the decision once per login (cached in
     * termsService) and, when acceptance is required, forces authenticated users to the `/terms`
     * takeover before any other state. Returns a redirect target state name, or `undefined` to
     * proceed. Fails open — termsService.resolve() never rejects.
     *
     * Runs after the auth check in the transition chain, so unauthenticated users are sent to
     * `login` first and never reach here.
     */
    function checkTermsAccepted(toState) {
      if (!authService.authentication.isAuth) {
        return $q.when();
      }

      const isTermsState = toState.name === 'terms';

      return termsService.resolve().then(function() {
        if (termsService.mustAccept) {
          // Allow the acceptance page itself; gate every other destination.
          return isTermsState ? undefined : 'terms';
        }

        // Gate inactive: keep authenticated users off the standalone /terms page.
        if (isTermsState) {
          return 'dashboard.main';
        }

        return undefined;
      });
    }

    function _verifyPermissions(toState) {
      if (toState.data.requireAccount && ('dashboard.account' !== toState.name) && !accountsService.currentAccount && !accountsService.currentAccounts) {
        return 'dashboard.account';
      }
      // Check permission of user for a specific state
      if (toState.data.permission && !accountsService.hasAccess(toState.data.permission.type, toState.data.permission.permission)) {
        const defaultPermission = accountsService.getAccountDefaultPermissionItem();

        if (defaultPermission === 'CallLog' && !featureFlags.isOn('old-reporting')) {
          return 'dashboard.call-logs.create-report';
        }

        return _.result(_.find($state.get(), {data:{permission:{type:defaultPermission}}}), 'name');
      }
    }

  }
})();
